import { useRoutes } from './router'
import {BrowserRouter as Router} from 'react-router-dom'
import './styles/main.scss'
import './styles/media.scss'
import './styles/dark.scss'
import {useAuth} from "./hooks/auth.hook";
import {AuthContext} from "./context/authcontext";
import {useSelector} from "react-redux";

function App() {

    const {token, login, logout, userId} = useAuth()
    const isAuthenticated = !!token
    const router = useRoutes(isAuthenticated)
    const theme = useSelector(state => state.app.theme)

    window.onclick = function (event) {
        if (event.target === document.querySelector('.modal') || event.target === document.querySelector('.functional-layer')) {
            document.querySelector('.modal-wrapper').style.cssText = "opacity: 0; visibility: hidden;"
        }
    }

    return (
        <AuthContext.Provider value={{
            token, login, logout, userId
        }}>
            <div className={`theme-wrapper ${theme}`}>
                <Router>
                    {router}
                </Router>
            </div>
        </AuthContext.Provider>
    );
}

export default App;
